export default {
  title: 'Confidentiality agreement',
  dialog: {
    cancel: 'Cancel',
    agree: 'Agree',
  },
}
